<template>

    <div class="shadow overflow-hidden">

      <div>

        <dl>
          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.number') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.number }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.employee') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.employee_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.violation') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.violation_description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.punishment') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.punishment_description }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.transaction_date') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.transaction_date }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.expired_date') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.expired_date }}
            </dd>
          </div>

          <!-- <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.school') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.school_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.branch') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.branch_name }}
            </dd>
          </div> -->

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.decree_no') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.decree_no }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
                {{ $t('punishmentTransaction.file_name') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                <p class="cursor-pointer text-blue-600 underline" @click="download(punishmentTransaction.file_name, '/download-punishment', punishmentTransaction.id)" :title="punishmentTransaction.file_name">
                    {{ punishmentTransaction.file_name }}
                </p>
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.remarks') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.remarks }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.proposed_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.proposed_by_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.pic1') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.pic1_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.pic2') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.pic2_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.witness1') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.witness1_name }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.witness2') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.witness2_name }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.created_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.created_by }}
            </dd>
          </div>

          <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentMaster.updated_by') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.updated_by }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentMaster.created_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.created_at }}
            </dd>
          </div>

          <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt class="text-base font-medium text-gray-500 dark:text-white">
              {{ $t('punishmentTransaction.updated_at') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
              {{ punishmentTransaction.updated_at }}
            </dd>
          </div>

        </dl>
      </div>

    </div>

    </template>
    <script>
    // /* eslint-disable */
    import { ref, reactive, watchEffect } from 'vue'
    import axios from 'axios'
    import { axiosDocument } from '@/boot/axios'
    import { useToast } from 'vue-toastification'
    export default {
      name: 'Punishment Master Detail Form',
      components: {
      },
      props: {
        propObject: {
          type: Object,
          default: () => ({ empty: true })
        },
        propClass: {
          type: Object,
          default: () => ({ empty: true })
        }
      },
      data: function () {
        return {
        }
      },
      emits: ['close-modal', 'submit'],
      setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const toast = useToast()
        // const activeTab = ref(0)

        const punishmentTransaction = reactive({
            id: '',
            transaction_date: '',
            number: '',
            employee_name: '',
            violation_description: '',
            punishment_description: '',
            school_name: '',
            branch_name: '',
            decree_no: '',
            file_name: '',
            remarks: '',
            expired_date: '',
            proposed_by_id: '',
            pic1_id: '',
            pic2_id: '',
            witness1_id: '',
            witness2_id: '',
            created_by: '',
            created_at: ''
        })

        const download = (name, url, id) => {
        const params = { filename: name, id }

        axios
            .get(url, { params, responseType: 'blob' })
            .then((response) => {
            triggerDownload(response.data, name)
            })
            .catch((error) => {
            console.error('Primary download failed:', error)
            // toast.error('Download failed: ' + (error.response?.data?.message || error.message))

            // Fallback
            downloadDoc(name, id)
            })
        }

        const downloadDoc = (name, id) => {
            const params = { filename: name, id }

            axiosDocument
                .get('/download-punishment', { params, responseType: 'blob' })
                .then((response) => {
                triggerDownload(response.data, name)
                })
                .catch((error) => {
                console.error('Fallback download failed:', error)
                toast.error('Fallback failed: ' + (error.response?.data?.message || error.message))
                })
        }

        const triggerDownload = (blobData, filename) => {
            const fileURL = window.URL.createObjectURL(new Blob([blobData]))
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', filename)
            document.body.appendChild(fileLink)
            fileLink.click()
            document.body.removeChild(fileLink)
            window.URL.revokeObjectURL(fileURL)
        }

        watchEffect(() => {
          const newpunishmentTransaction = props.propObject
          Object.assign(punishmentTransaction, newpunishmentTransaction)
        })

        watchEffect(() => {
          const newpunishmentTransaction = props.propClass
          Object.assign(punishmentTransaction, newpunishmentTransaction)
        })

        return {
          titleStack,
          download,
          downloadDoc,
          punishmentTransaction
        }
      }
    }
    </script>
